import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import TableFormFonts from './TableFormFont'
import TableFormStyle from './TableFormStyle'
import type { TableFormBrandType, TableBrandForms } from './tableTypes'

const FORM_MAP: TableBrandForms = {
  [BrandFormEnum.STYLE]: TableFormStyle,
  ...TableFormFonts,
}

const TableFormBrand: TableFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(TableFormBrand) as typeof TableFormBrand
